<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" aria-label="Close" @click="onSuccessMessageCloseClick">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" aria-label="Close" @click="errorMessageCloseClick">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div v-if="!loading">
                    <h5>Upload Additional Document</h5>
                    <div class="form-group">
                        <label>Document Type</label>
                        <div class="text-danger">
                            {{documentToUpload.documentTypeId.errorMessage}}
                        </div>
                        <bootstrap-select  :selectOptions="documentTypes" :selectedOption="documentToUpload.documentTypeId.value" :elementId="'documentTypeSelect'"
                                           :returnSelectedOptionText="true"
                                           @changeSelect="onDocumentTypeSelect"></bootstrap-select>
                    </div>
                    <div class="form-group">
                        <div class="text-danger">
                            {{documentToUpload.file.errorMessage}}
                        </div>
                        <div class="custom-file">
                            <input type="file" class="custom-file-input" id="releaseSlipInput" @change="onDocumentAttach" aria-describedby="fileHelpReleaseSlip"
                                   accept="image/png, image/jpeg, .pdf">
                            <label class="custom-file-label text-truncate" for="releaseSlipInput" v-if="documentToUpload.file.value === null">
                                Choose Document
                            </label>
                            <label class="custom-file-label text-truncate" for="releaseSlipInput" v-if="documentToUpload.file.value !== null">
                                {{documentToUpload.file.value.name}}
                            </label>
                            <small id="fileHelpReleaseSlip" class="form-text text-muted">Only images and PDFs are accepted. File attached cannot exceed 2MB</small>
                        </div>
                    </div>
                    <button class="btn btn-primary" @click="onUploadClick">Upload</button>
                </div>
                <br>
                <hr>
                <data-table
                        :headings="documentsHeadings"
                        :data="documents"
                        :hasActions="true"
                        :hasCustomActionComponent="true"
                        :hasNoPaging="true"
                        :hasNoFilter="true"
                        v-if="!loading">
                    <template #actionComponent="{ documentId }">
                        <button class="btn btn-link" @click="downloadDocument(documentId)">
                            Download
                        </button>
                    </template>
                </data-table>
                <loading-spinner :showSpinner="loading"></loading-spinner>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" :disabled="loading" @click="onModalCloseClick" >Close</button>
            </div>
        </div>
    </div>
</div>